import React from 'react';
import SEO from '../components/SEO';

const CookiePolicy = () => {
  return (
    <div className="bg-white text-black min-h-screen p-8 mt-12">
      <SEO
        title="Cookie Policy - Hive Workspaces"
        description="Read Hive Workspaces cookie policy. Learn how we use cookies to improve your browsing experience."
        canonical="/cookie-policy"
      />
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-center mb-8 text-gray-800 uppercase">
          COOKIE POLICY
        </h1>

        <div className="space-y-8">
          <section className="border-b border-gray-200 pb-6">
            <h2 className="text-2xl font-semibold mb-4 text-gray-700">1. Consent</h2>
            <p className="text-gray-800 leading-relaxed">
              We may store cookies on your device when they are strictly necessary for
              the operation of this website. For all other types of cookies, your
              permission is required. Necessary cookies are processed under GDPR Art.
              6 (1)(f), while analytics, preference and marketing cookies require your
              consent under GDPR Art. 6 (1)(a).
            </p>
            <p className="text-gray-800 leading-relaxed mt-2">
              You may change or withdraw your cookie consent at any time on our website.
            </p>
          </section>

          <section className="border-b border-gray-200 pb-6">
            <h2 className="text-2xl font-semibold mb-4 text-gray-700">2. Your Choices Regarding Cookies</h2>
            <p className="text-gray-800 leading-relaxed">
              You can avoid cookies by disabling them in your browser settings, then
              deleting any stored cookies. If you block cookies, some website features
              may not work properly.
            </p>
            <p className="text-gray-800 leading-relaxed mt-2">
              For instructions on deleting or blocking cookies, refer to your browser’s
              help pages.
            </p>
          </section>

          <section className="border-b border-gray-200 pb-6">
            <h2 className="text-2xl font-semibold mb-4 text-gray-700">3. What If I Want To Control My Cookie Permissions?</h2>
            <p className="text-gray-800 leading-relaxed">
              You can configure your browser to alert you when cookies are sent, block
              them entirely, or remove existing cookies. Some functionality may be
              affected if cookies are disabled.
            </p>
            <button
              onClick={() => window.dispatchEvent(new Event("open-cookie-consent"))}
              className="mt-4 px-4 py-2 bg-orange-500 text-white rounded font-medium hover:bg-orange-600 transition-colors"
            >
              Renew or change your cookie consent
            </button>
          </section>

          <section className="border-b border-gray-200 pb-6">
            <h2 className="text-2xl font-semibold mb-4 text-gray-700">4. About Cookies Policy</h2>
            <p className="text-gray-800 leading-relaxed">Our Cookies Policy was last updated on 24 July 2024.</p>
            <p className="text-gray-800 leading-relaxed mt-2">
              This website uses cookies to enhance your browsing experience. Cookies
              help recognize your device and remember your preferences.
            </p>
            <p className="text-gray-800 leading-relaxed mt-2">
              Cookies do not store personal or sensitive information like passwords or
              payment details. For more information on how we protect your data,
              please refer to our Privacy Policy.
            </p>
          </section>

          <section className="border-b border-gray-200 pb-6">
            <h2 className="text-2xl font-semibold mb-4 text-gray-700">5. Interpretation and Definitions</h2>
            <div className="space-y-4">
              <p className="text-gray-800 leading-relaxed">
                <strong>“Company”</strong> refers to us (“the Company”, “We”, “Us”, or
                “Our”).
              </p>
              <p className="text-gray-800 leading-relaxed">
                <strong>“Cookies”</strong> means small files stored on your device by a
                website.
              </p>
              <p className="text-gray-800 leading-relaxed">
                <strong>“Website”</strong> refers to our site and related services.
              </p>
              <p className="text-gray-800 leading-relaxed">
                <strong>“You”</strong> means any individual or entity using the Website.
              </p>
            </div>
          </section>

          <section className="border-b border-gray-200 pb-6">
            <h2 className="text-2xl font-semibold mb-4 text-gray-700">6. How We Use Cookies</h2>
            <p className="text-gray-800 leading-relaxed">
              We use cookies to analyze website usage, improve your browsing experience,
              and deliver relevant content or ads when applicable.
            </p>
            <p className="text-gray-800 leading-relaxed mt-2">
              All cookies we use are anonymous and help optimize performance or show
              relevant promotions based on your visits.
            </p>
          </section>

          <section className="border-b border-gray-200 pb-6">
            <h2 className="text-2xl font-semibold mb-4 text-gray-700">7. Type of Cookies We Use</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-gray-700">Necessary cookies</h3>
                <p className="text-gray-800 leading-relaxed">Enable basic functionality and secure access.</p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-700">Preferences cookies</h3>
                <p className="text-gray-800 leading-relaxed">Remember settings such as language and region.</p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-700">Statistics cookies</h3>
                <p className="text-gray-800 leading-relaxed">Help us understand how visitors interact with the site.</p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-700">Marketing cookies</h3>
                <p className="text-gray-800 leading-relaxed">Used to deliver relevant ads.</p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-700">Unclassified cookies</h3>
                <p className="text-gray-800 leading-relaxed">Cookies that are still being analyzed and categorized.</p>
              </div>
            </div>
          </section>

          <section className="pb-8">
            <h2 className="text-2xl font-semibold mb-4 text-gray-700">8. Contact Us</h2>
            <p className="text-gray-800 leading-relaxed">
              If you have questions about this Cookies Policy, you can contact us
              through our support or contact page.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
